import {
  Alert,
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  SxProps,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { GreenPaper } from "../../components";
import { FormEvent, useState } from "react";
import { useAuth } from "../../context";
import { Navigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios, { AxiosError } from "axios";
import { axiosInstance } from "../../utils";
import { enqueueSnackbar } from "notistack";
import Header from "../../web/src/components/Header";
import Footer from "../../web/src/components/Footer";

export const AdminLoginPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const { login, error, isLoading, user } = useAuth();

  const [loading, setLoading] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [email, setEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    login(form.email, form.password);
  };

  const onForgot = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (email.trim().length === 0) {
      return;
    }

    setLoading(true);
    try {
      await axiosInstance.post("/api/auth/forgot-password", {
        email,
      });
          
      enqueueSnackbar("Şifre yenileme bağlantısı emailinize gönderildi", {
        variant: "success",
      });
      setShowForgotModal(false);
      setEmail("");
    } catch (error) {
      if(error instanceof AxiosError && error.response?.status == 404){
        enqueueSnackbar("Kullanıcı bulunamadı", { variant: "error" });
      }
    }
    setLoading(false);
  };

  if (user) {
    if (user.role === "service_provider") {
      return <Navigate to="/portal/admin/service" />;
    }
    return <Navigate to={"/portal/admin"} />;
  }

  const ButtonHover: SxProps = {
    "&:hover": {
      backgroundColor: "#ed6c02",
      color: "white"
    }
  }

  return (
    <>
      <div className="web-app-new-project-1234">
        <Header />
      </div>
      <Container
        maxWidth={!isMobile ? false : "xl"}
        sx={
          !isMobile
            ? {
                width: "95vw",
                px: 2,
                mx: "auto",
                mt: 30,
              }
            : {}
        }
      >
        <Dialog
          maxWidth="xs"
          fullWidth
          open={showForgotModal}
          onClose={() => setShowForgotModal(false)}
        >
          <form onSubmit={onForgot}>
            <Typography sx={{ p: 3, fontSize: "18px", pb: 0 }}>
              Şifremi Unuttum
            </Typography>
            <DialogContent>
              <TextField
                helperText="Şifrenizi sıfırlamanız için email adresine link göndereceğiz."
                label="E-posta"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                autoFocus
                type="email"
                required
              />
            </DialogContent>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="end"
              sx={{ p: 3, pt: 0, gap: 3 }}
            >
              <Button onClick={() => setShowForgotModal(false)}>İptal</Button>
              <Button
                disabled={loading}
                type="submit"
                variant="contained"
                color="secondary"
              >
                Şifremi Yenile
              </Button>
            </Stack>
          </form>
        </Dialog>

        <Box
          sx={{
            backgroundColor: "white",
            borderBottomLeftRadius: "24px",
            borderBottomRightRadius: "24px",
            pb: 4,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: 4,
              py: 16,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                maxWidth: 542,
                flex: 1,
                borderRadius: 4,
                p: 3,
                border: "1px solid",
                borderColor: "divider",
                backgroundColor: "#f7f7f7"
              }}
            >
              <form onSubmit={onSubmit}>
                <Stack gap={4}>
                  <Stack gap={1.5}>
                    <Typography
                      sx={{
                        fontSize: "24px",
                        lineHeight: "32px",
                        fontWeight: 500,
                        color: "#ed6c02"
                      }}
                    >
                      Bayi Portalı
                    </Typography>
                  </Stack>
                  <Stack gap={1.5}>
                    <TextField
                      color="warning"
                      required
                      type="email"
                      label={"Eposta"}
                      value={form.email}
                      onChange={(e) => {
                        setForm((cur) => ({
                          ...cur,
                          email: e.target.value,
                        }));
                      }}
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                    />
                    <TextField
                      color="warning"
                      required
                      type={showPassword ? "text" : "password"}
                      label={"Şifre"}
                      value={form.password}
                      onChange={(e) => {
                        setForm((cur) => ({
                          ...cur,
                          password: e.target.value,
                        }));
                      }}
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                        input: {
                          endAdornment: (
                            <IconButton
                              onClick={() => {
                                setShowPassword((p) => !p);
                              }}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          ),
                        },
                      }}
                    />
                    <Typography
                      onClick={() => {
                        setEmail("");
                        setShowForgotModal(true);
                      }}
                      sx={{
                        fontSize: "12px",
                        lineHeight: "16px",
                        color: "#ed6c02",
                        cursor: "pointer",
                        textAlign: "right",
                      }}
                    >
                      Şifremi Unuttum
                    </Typography>
                  </Stack>
                  <Button
                    sx={ButtonHover}
                    disabled={isLoading}
                    size="large"
                    type="submit"
                    variant="outlined"
                    color="warning"
                  >
                    Giriş Yap
                  </Button>
                  {error && <Alert severity="error">{error}</Alert>}
                </Stack>
              </form>
            </Box>
          </Box>
        </Box>
      </Container>
      <div className="web-app-new-project-1234">
        <Footer />
      </div>
    </>
  );
};
